<template>
    <div class="p-mypage__information">
        <dl>
            <dt><button class="c-btn__information"><span class="icon"><img
                            src="@/assets/img/ui_parts/svg/icon_information.svg" alt="!" /></span>{{ $t('LABEL_NEWS') }}</button></dt>
            <dd>
                <article v-for="news in topPageStore.newsList">
                    <p class="date">{{ news.updated_at }}</p>
                    <h2 class="title"><a href="#">{{ news.title }}</a></h2>
                    <p class="txt" v-html="news.content"></p>
                </article>
            </dd>
        </dl>
    </div>
</template>

<script setup>
import { useTopPageStore } from "@/stores/topPageStore";

const topPageStore = useTopPageStore();
</script>